// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"EnableMemberModal_FormTitle_3ITEg","Label":"EnableMemberModal_Label_JxzIR"};